import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CollapsibleTagListProps<T> {
  items: T[];
  renderTag: (item: T) => React.ReactNode;
  maxVisibleItems: number;
  seeAllText?: string;
  textColor?: string;
}

export const CollapsibleTagList = <T,>({
  items,
  renderTag,
  maxVisibleItems,
  textColor = 'text-rw-sub',
}: CollapsibleTagListProps<T>) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  const displayedItems = showAll ? items : items.slice(0, maxVisibleItems);
  const hasMore = items.length > maxVisibleItems;

  return (
    <>
      {displayedItems.map((item, index) => (
        <React.Fragment key={index}>{renderTag(item)}</React.Fragment>
      ))}
      {hasMore && !showAll && (
        <button
          onClick={() => setShowAll(true)}
          className={`self-end text-sm font-semibold underline ${textColor}`}
        >
          {t('全部見る...')}
        </button>
      )}
    </>
  );
};
